<template>
	<div class="d-flex align-items-center mt-2">
		<div
			class=""
			:class="isLaptop ? 'mr-3 ' : ''"
			v-if="!skill.parser && $route.name == 'CandidateDashboard'"
		>
			<img
				class="drag-handle"
				src="../../../assets/newdesign/dashboard/6dots.svg"
				alt=""
			/>
		</div>
		<div
			class="d-flex p-2 mt-2 position-relative mob-align-items-start"
			:class="{
				'candash-red-details-box': skill.parser,
				'candash-blue-details-nowid': !skill.parser,
				'resume-builder-card-width':
					!skill.parser && $route.name === 'CandidateDashboard',
				'w-100': skill.parser || $route.name !== 'CandidateDashboard',
			}"
		>
			<img
				class="mr-3 lapicon"
				src="../../../assets/newdesign/dashboard/skillDp.svg"
				alt=""
			/>
			<img
				class="mr-2 mobicon"
				src="@/assets/newbuilder/mob-skills.svg"
				alt=""
			/>
			<div
				class="d-flex align-items-center justify-content-between mob-w-88 w-100"
			>
				<div class="mob-w-95 w-75 text-capitalize">
					<div
						class="bold-bluetxt"
						:class="skill.skillName ? '' : 'not-mention-txt'"
					>
						{{ skill.skillName ? skill.skillName : "Not Mentioned" }}
					</div>
					<div
						:class="isLaptop ? 'mt-2' : 'mt-1'"
						class="d-flex align-items-center candash-displaytxt-grey-2 fw-500"
					>
						<!-- <div v-if="skill.yearsOfExp">
							{{ skill.yearsOfExp
							}}{{ skill.yearsOfExp > 1 ? "Years" : "Year" }}
						</div>
						<div v-else>---</div> -->

						<div
							class="candash-skillTag caps-first"
							:class="skill.expertiseLevel ? '' : 'not-mention-txt'"
						>
							{{
								skill.expertiseLevel ? skill.expertiseLevel : "Not Mentioned"
							}}
						</div>
					</div>
				</div>
				<div class="laptop-ed-icons">
					<img
						@click.stop="openEdit()"
						class="mr-2 pointer blueShadow"
						src="../../../assets/newdesign/dashboard/blueEdit1.svg"
						alt=""
					/>
					<img
						@click.stop="deleteData()"
						src="../../../assets/newdesign/dashboard/blueDelete1.svg"
						alt=""
						class="pointer mr-2 blueShadow"
					/>
					<img
						v-if="skill.parser"
						src="../../../assets/newdesign/dashboard/disableadd.svg"
						alt=""
					/>
				</div>

				<div
					class="mobile-ed-icons"
					@click.stop="$emit('select-card', skill.uniqueID)"
				>
					<img src="@/assets/newbuilder/threedots.svg" alt="" />
					<div
						class="ed-box"
						v-if="selectedCard == skill.uniqueID"
						:ref="'cardopen' + skill.uniqueID"
					>
						<div
							class="ed-box-option d-flex align-items-center pl-2 pointer"
							@click.stop="openEdit()"
						>
							<img
								src="@/assets/newbuilder/ddedit.svg"
								class="mr-2"
								alt=""
							/>Edit
						</div>
						<div
							class="ed-box-option d-flex align-items-center pl-2 pointer"
							@click="deleteData()"
						>
							<img
								src="@/assets/newbuilder/delete.svg"
								class="mr-2"
								alt=""
							/>Delete
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SkillCard",
	data() {
		return {};
	},
	mounted() {
		document.addEventListener("click", this.clickon);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.clickon);
	},
	props: {
		selectedCard: String,
		skill: Object,
		isLaptop: Boolean,
		formConfiguration: Object,
		form: Object,
	},
	methods: {
		openEdit() {
			this.$emit("edit-form", {
				form: this.form,
				content: this.skill,
				id: this.skill.uniqueID,
			});
		},
		deleteData() {
			this.$emit("delete-data", {
				form: this.form,
				content: this.skill,
			});
		},
		clickon() {
			let id = "cardopen" + this.skill.uniqueID;
			if (this.$refs[id] && !this.$refs[id].contains(event.target)) {
				this.$emit("select-card", "");
			}
		},
	},
};
</script>

<style></style>
